import { auth } from "../firebase.js";

const getApiUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_API_URL || '';
  return `${baseUrl}${endpoint}`;
};

const getAuthHeaders = async (isJson = true) => {
  const token = await auth.currentUser.getIdToken(true)
  const headers = {
    'Authorization': `Bearer ${token}`,
  };
  
  if (isJson) {
    headers['Content-Type'] = 'application/json';
  }
  
  return headers;
};

export const authFetch = async (url, options = {}, isJson = true) => {
  const headers = await getAuthHeaders(isJson);
  return fetch(getApiUrl(url), {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
  });
};